const fieldLabelKeys: Record<string, string> = {
  'page-html': 'fieldPageHtml',
  'page-url': 'fieldPageUrl',
  'visible-text': 'fieldVisibleText',
  'page-title': 'fieldPageTitle',
  'page-title-length': 'fieldPageTitleLength',
  'h1-text': 'fieldH1Text',
  'h2-text': 'fieldH2Text',
  'h3-text': 'fieldH3Text',
  'heading-length': 'fieldHeadingLength',
  'font-family-used': 'fieldFontFamilyUsed',
  'font-family-count': 'fieldFontFamilyCount',
  'font-weight-used': 'fieldFontWeightUsed',
  'image-filename': 'fieldImageFilename',
  'image-size': 'fieldImageSize',
  'meta-header-name': 'fieldMetaHeaderName',
  'meta-header-content': 'fieldMetaHeaderContent',
  'meta-length': 'fieldMetaLength',
  'file-size': 'fieldFileSize',
  'link-text-length': 'fieldLinkTextLength',
  'external-link-count': 'fieldExternalLinkCount',
};

const operatorLabelKeys: Record<string, string> = {
  'starts-with': 'operatorStartsWith',
  'ends-with': 'operatorEndsWith',
  contains: 'operatorContains',
  'not-contains': 'operatorDoesNotContain',
  'contains-words': 'operatorContainsPhrases',
  'not-contains-words': 'operatorContainsNoPhrases',
  equal: 'operatorEqual',
  equals: 'operatorEqual',
  'not-equal': 'operatorNotEqual',
  'not-equals': 'operatorNotEqual',
  'in-list': 'operatorInList',
  'not-in-list': 'operatorNotInList',
  'matches-blocked-terms-file': 'operatorMatchesBlockedTermsFile',
  regex: 'operatorRegex',
  matches: 'operatorRegex',
  'less-than': 'operatorLessThan',
  'greater-than': 'operatorGreaterThan',
  'less-than-or-equal': 'operatorLessThanOrEqual',
  'greater-than-or-equal': 'operatorGreaterThanOrEqual',
};

export function getRuleFieldLabel(field: string) {
  return fieldLabelKeys[field] ?? 'unknownPolicyField';
}

export function getRuleOperatorLabel(operator: string) {
  return operatorLabelKeys[operator] ?? 'unknownPolicyOperator';
}
